import React, {useCallback, useRef} from 'react';

export const useDoubleClick = (callback, doubleClick=250) => {
    let ref = useRef(0);
    const onDoubleClick = useCallback(() => {
        let date = new Date().getTime();
        if (date - ref.current <= doubleClick) {
            callback();
            return;
        }
        ref.current = date;
    }, [callback]);

    return onDoubleClick;
};
